<!--  设备管理 -->
<template>
  <div class="administrat mainContent">
    <div v-if="!showMore" class="main_content">
      <!--  左侧 -->
      <transition name="moveL">
        <div class="left_li" v-show="flag2">
          <!--  设备数量统计 -->
          <div class="content_box">
            <div class="title_box">
              <div class="new_title">{{ $t('EquipmentQuantityStatistics') }}</div>
            </div>
            <div class="equipment_num">
              <div class="amount" v-for="(item, indx) in amountList" :key="indx">
                <div class="num">{{ item.num }}</div>
                <div class="equip_name">{{ item.name }}</div>
              </div>
            </div>
          </div>
          <!--  设备分配状态统计 -->
          <div class="content_box equipment_statu">
            <div class="title_box">
              <div class="new_title">{{ $t('EquipmentAllocationStatusStatistics') }}</div>
            </div>
            <div class="pie_chart">
              <EquipmentNum
                :chartId="chartId"
                :echartData="distributData"
                :seriesSize="pieSeriesSize"
                :legendY="16"
              ></EquipmentNum>
            </div>
          </div>
        </div>
      </transition>
      <div class="center-li">
        <!--  设备状态告警 -->
        <div class="content_box healty_statu">
          <DeviceStatusAlarm :currenNode="currenNode" @showMore="checkMore(mainTitle.statusTitle, '', 'device')"></DeviceStatusAlarm>
        </div>
        <!--  设备剩余电量 -->
        <div class="content_box device_dyn">
          <div class="record">
            <div class="title_box">
              <div class="new_title">{{ $t('RemainingPowerEquipment') }}</div>
            </div>
            <div class="check_more" v-if="dynamicMore" @click="checkMore(mainTitle.dynamicTitle, '', 'device')">
              {{ $t('SeeMore') }}>
            </div>
          </div>
          <div class="healthy_alarm">
            <DeviceDynamic :currenNode="currenNode" @deviceBtnShow="deviceBtnShow"></DeviceDynamic>
          </div>
        </div>
      </div>
      <!-- 机构树搜索 用作于数据刷新 机构id需要 ，不注释-->
      <div class="searchTree">
        <SearchTree @currentNode="currentNode"></SearchTree>
      </div>
      <!--  右侧 -->
      <transition name="moveR">
        <div class="right_li" v-show="flag2">
          <!--  设备运行时间 -->

          <div class="content_box">
            <div class="title_box">
              <div class="new_title">{{ $t('EquipmentRunningTime') }}</div>
            </div>
            <div class="pie_chart">
              <EquipmentNum
                :chartId="runChartId"
                :echartData="quipmentRunData"
                :seriesSize="pieSeriesSize"
                :legendY="16"
              ></EquipmentNum>
            </div>
          </div>
          <!--  在线设备统计 -->
          <div class="content_box">
            <div class="title_box">
              <div class="new_title">{{ $t('OnlineEquipmentStatistics') }}</div>
            </div>
            <div class="pie_chart">
              <EquipmentNum
                :chartId="onlineChartId"
                :echartData="onlineData"
                :seriesSize="pieSeriesSize"
                :legendY="16"
              ></EquipmentNum>
            </div>
          </div>
        </div>
      </transition>
      <div class="date_search">
        <!-- 查询条件 -->
      </div>
    </div>
    <div v-if="showMore" class="main_content">
      <CheckMore
        @backHome="backHome"
        :moreTitle="moreTitle"
        :type="echartType"
        :echartData="echartData"
        :currenNode="currenNode"
      ></CheckMore>
    </div>
  </div>
</template>

<script>
// 依赖组件
import EquipmentNum from '@/views/new-home/EquipmentNum.vue'
import DeviceDynamic from '@/views/new-device/DeviceDynamic.vue'
import SearchTree from '@/views/new-home/SearchTree.vue'
import CheckMore from '@/views/new-more/CheckMore.vue'
import DeviceStatusAlarm from '@/views/new-device/DeviceStatusAlarm'
// 依赖工具
import { findStatus } from '@/api/Cockpit'
import { deviceCountType, deviceCountDistribut, deviceCountTime } from '@/api/new-device/newDevice'
import { nowDate, beforeMonthDate } from '@/util/date'
import { mapGetters } from 'vuex'
export default {
  components: {
    EquipmentNum,
    SearchTree,
    DeviceDynamic,
    CheckMore,
    DeviceStatusAlarm,
  },
  data() {
    return {
      // 显示动画
      flag2: false,
      quipmentNumData: {},
      // 设备分配状态echartId
      chartId: 'equipmentStatu',
      // 设备分配状态数据
      distributData: [
        { y: 0, name: this.$t('Unassigned') },
        { y: 0, name: this.$t('Assigned') },
      ],
      // 设备数量统计数据
      amountList: [
        { num: 0, name: this.$t('IntelligentSafetyHelmet'), show: true },
        { num: 0, name: this.$t('LawEnforcemenInstrument'), show: !this.isOnlySupportIPC },
      ],
      runChartId: 'equipmentRun',
      // 统计设备运行时间情况
      quipmentRunData: [],
      onlineChartId: 'onlineChartId',
      // 在线设备统计数据
      onlineData: [
        { y: 0, name: this.$t('onLine') },
        { y: 0, name: this.$t('offLine') },
        { y: 0, name: this.$t('Unbound') },
      ],

      // 设备动态信息展示
      dynamicsData: [],
      // 设备动态all信息
      allDynamics: [],
      currenNode: { id: '', startTime: beforeMonthDate() + ' 00:00:00', endTime: nowDate() + ' 23:59:00' },
      loading: false,
      mainTitle: { dynamicTitle: this.$t('RemainingPowerEquipment'), statusTitle: this.$t('EquipmentStatusAlarm') },
      // 显示更多的内容弹窗
      showMore: false,
      // 更多的标题传值
      moreTitle: '',
      echartType: '',
      echartData: [],
      //
      dynamicMore: false,

      pieSeriesSize: 200,
    }
  },
  computed: {
    ...mapGetters(['isOnlySupportIPC', 'isDefaultTheme']),
  },
  methods: {
    deviceBtnShow(type) {
      this.dynamicMore = type
    },
    // 返回
    backHome() {
      this.showMore = false
    },
    // 查看更多
    checkMore(title, data, type) {
      this.moreTitle = title
      this.echartType = type
      this.showMore = true
    },
    // 刷新数据
    refreshData() {
      this.getCountType()
      this.getdeviceDistribut()
      this.getEquipment()
      this.getdeviceTime()
    },
    // 结构树当前节点（用户头盔）
    currentNode(item) {
      this.currenNode.id = item.id
      this.currenNode = Object.assign({}, this.currenNode)
      this.refreshData()
    },

    // 查询该租户的设备是否在线数
    getEquipment() {
      findStatus({ ouId: this.currenNode.id }).then(res => {
        if (res.state === 0) {
          this.onlineData = []
          for (let item of res.data) {
            let num = Number(item.number)
            if (item.status === '2' && num !== 0) {
              this.onlineData.push({
                y: num,
                name: this.$t('Unbound') + this.$t('NumberEquipment'),
                color: '#35E878',
              })
            } else if (item.status === '1' && num !== 0) {
              this.onlineData.push({
                y: num,
                name: this.$t('onLine') + this.$t('NumberEquipment'),
                color: '#2096FF',
              })
            } else if (item.status === '0' && num !== 0) {
              this.onlineData.push({
                y: num,
                name: this.$t('offLine') + this.$t('NumberEquipment'),
                color: '#FFD96A',
              })
            }
          }
        }
      })
    },
    // 查询设备数
    getCountType() {
      deviceCountType({ ouId: this.currenNode.id }).then(res => {
        if (res.state === 0) {
          this.amountList = []
          this.amountList.push({
            num: res.data.helmet,
            name: this.$t('IntelligentSafetyHelmet'),
          })
          if (!this.isOnlySupportIPC) {
            this.amountList.push({
              num: res.data.pda,
              name: this.$t('LawEnforcemenInstrument'),
            })
          }
        }
      })
    },
    // 统计设备分配状态情况
    getdeviceDistribut() {
      deviceCountDistribut({ ouId: this.currenNode.id }).then(res => {
        if (res.state === 0) {
          this.distributData = []
          if (res.data.distributed !== 0) {
            this.distributData.push({
              y: res.data.distributed,
              name: this.$t('Unassigned'),
              color: '#2096FF',
            })
          }
          if (res.data.undistributed !== 0) {
            this.distributData.push({
              y: res.data.undistributed,
              name: this.$t('Assigned'),
              color: '#FFD96A',
            })
          }
        }
      })
    },
    // 统计设备运行时间
    getdeviceTime() {
      deviceCountTime({ ouId: this.currenNode.id }).then(res => {
        if (res.state === 0) {
          this.quipmentRunData = []
          if (res.data.year !== 0) {
            this.quipmentRunData.push({
              y: res.data.year,
              name: this.$t('HalfYeaOneYear'),
              color: '#2096FF',
            })
          }

          if (res.data.halfYear !== 0) {
            this.quipmentRunData.push({
              y: res.data.halfYear,
              name: this.$t('ThreeToSixMonths'),
              color: '#FFD96A',
            })
          }

          if (res.data.overYear !== 0) {
            this.quipmentRunData.push({
              y: res.data.overYear,
              name: this.$t('OneYarAndAbove'),
              color: '#35E878',
            })
          }

          if (res.data.quarter !== 0) {
            this.quipmentRunData.push({
              y: res.data.quarter,
              name: this.$t('WithinThreeMonths'),
              color: '#3CFFC4',
            })
          }
        }
      })
    },
  },
  created() {
    let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    if (width < 1441) {
      this.pieSeriesSize = 120
    } else if (width > 1441) {
      this.pieSeriesSize = 220
    }
  },
  mounted() {
    this.flag2 = true
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.mainContent
  position relative
  height 100%
  .main_content
    height 100%
  .content_box
    width 600px
    height 47.5%
    margin-left 20px
    margin-top 20px
    pointer-events: auto
    .record
      position relative
      .check_more
        position: absolute
        right: 15px
        top 50%
        transform: translate(0,-50%)
        text-align: center
        line-height: 28px
        padding: 0 7px

        border-radius: 2px
        font-weight: bold

        font-size: 14px
        border-radius: 4px;
        cursor pointer
    .title_box
      .new_title
        height 46px
        line-height 46px
        padding-left 56px
        font-size: 18px;
        font-weight: bold
  .pie_chart
    height: calc(100% - 80px)
  .content_box:first-child
    margin-top 0px
  .left_li
    float: left
    height calc(100% - 20px)
    padding-top 20px
    margin-left 20px
  .equipment_num
    width 100%
    height: calc(100% - 46px)
    display flex
    justify-content: space-around
    align-items: center
    .amount
      width 36%
      margin-right 4px
      text-align center
      .num
        width 230px
        height 230px
        line-height 230px
        font-size: 60px
        color: #fff
        font-weight 600
        bg-image-full('~@/icon/home/circular.png')
      .equip_name
        margin-top 10px
        font-size: 20px
        font-weight: bold
    .amount:last-child
      margin-right 0
  .center-li
    width: calc(100% - 1280px)
    height calc(100% - 20px)
    float: left
    padding-top 20px
    .content_box
      width 100%
  .searchTree
    float left
    width 390px
    display: none
  .right_li
    position absolute
    right 0
    top 0
    height calc(100% - 20px)
    padding-top 20px
  .content_box
    margin 20px 20px 0 0
  .content_box:first-child
    margin-top 0px

  .healty_statu
    font-size: 22px
  .date_search
    position absolute
    right 520px
    top 0
    margin-top: 20px
    pointer-events: auto
// 深色样式
.theme-dark
  .mainContent
    .equipment_num
      .num
        color: #fff
        bg-image-full('~@/icon/home/ic_circular.png')
</style>
